export default __webpack_public_path__ + "static/media/Chat-Numbers-System-05.a64b0d6f.svg";